"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _core = require("@material-ui/core");

var _styles = require("@material-ui/styles");

var _HelpOutlineOutlined = _interopRequireDefault(require("@material-ui/icons/HelpOutlineOutlined"));

var _PlayArrowRounded = _interopRequireDefault(require("@material-ui/icons/PlayArrowRounded"));

var _Add = _interopRequireDefault(require("@material-ui/icons/Add"));

var _Edit = _interopRequireDefault(require("@material-ui/icons/Edit"));

var _Delete = _interopRequireDefault(require("@material-ui/icons/Delete"));

var _sweetalert = _interopRequireDefault(require("sweetalert2"));

var _sweetalert2ReactContent = _interopRequireDefault(require("sweetalert2-react-content"));

var _Notification = _interopRequireDefault(require("./Notification"));

var _urls = require("../utils/urls");

var _FullModal = _interopRequireDefault(require("./FullModal"));

var _services = _interopRequireDefault(require("../services"));

var _utils = _interopRequireDefault(require("../utils"));

var _Modal = _interopRequireDefault(require("./Modal"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var MySwal = (0, _sweetalert2ReactContent.default)(_sweetalert.default);
var useStyles = (0, _styles.makeStyles)(function () {
  return {
    colorHelp: {
      color: "#c7c7c7",
      cursor: "pointer"
    },
    playBtn: {
      color: "#28a745"
    },
    fabFloatingButton: {
      bottom: 20,
      left: "auto",
      margin: 0,
      position: "fixed",
      right: 20,
      top: "auto",
      zIndex: 100
    },
    titleHeader: {
      marginTop: 10,
      textAlign: "left"
    },
    notFound: {
      display: "flex",
      justifyContent: "center",
      marginTop: 50,
      color: "#9a9a9a"
    }
  };
});
var ITEM_HEIGHT = 48;
var ITEM_PADDING_TOP = 8;
var MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250
    }
  }
};
var FieldsGrid = (0, _styles.withStyles)({
  root: {
    "& > *": {
      padding: 8
    }
  }
})(_core.Grid);
var StyledTableCell = (0, _styles.withStyles)(function () {
  return {
    head: {
      backgroundColor: "transparent",
      color: "black"
    },
    body: {
      fontSize: 14
    }
  };
})(_core.TableCell);
var StyledTableRow = (0, _styles.withStyles)(function () {
  return {
    root: {
      "&:nth-of-type(odd)": {
        backgroundColor: "#f6f6f6"
      }
    }
  };
})(_core.TableRow);

var Wrapper = function Wrapper(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(_core.Grid, {
    container: true,
    spacing: 3
  }, children);
};

var FormItemSources = function FormItemSources(_ref2) {
  var _properties$source$pa;

  var properties = _ref2.properties,
      objectsForm = _ref2.objectsForm,
      handleItemSource = _ref2.handleItemSource,
      handleItemDependencies = _ref2.handleItemDependencies,
      handleAddItemForm = _ref2.handleAddItemForm,
      gridSize = _ref2.gridSize;

  var _useState = (0, _react.useState)(1),
      _useState2 = _slicedToArray(_useState, 2),
      typeSelect = _useState2[0],
      setTypeSelect = _useState2[1];

  var _useState3 = (0, _react.useState)(""),
      _useState4 = _slicedToArray(_useState3, 2),
      typeText = _useState4[0],
      setTypeText = _useState4[1];

  var _useState5 = (0, _react.useState)(""),
      _useState6 = _slicedToArray(_useState5, 2),
      typeServer = _useState6[0],
      setTypeServer = _useState6[1];

  var _useState7 = (0, _react.useState)({
    open: false,
    type: "",
    msg: ""
  }),
      _useState8 = _slicedToArray(_useState7, 2),
      openAlert = _useState8[0],
      setOpenAlert = _useState8[1];

  var type = (0, _react.useMemo)(function () {
    return properties.type;
  }, [properties.type]);
  (0, _react.useEffect)(function () {
    var _properties$source, _properties$source2, _properties$source3, _properties$source3$p;

    setTypeSelect((_properties$source = properties.source) === null || _properties$source === void 0 ? void 0 : _properties$source.type);
    setTypeText((_properties$source2 = properties.source) === null || _properties$source2 === void 0 ? void 0 : _properties$source2.defaultValues.map(function (d) {
      return d.value;
    }).toString());
    setTypeServer((_properties$source3 = properties.source) === null || _properties$source3 === void 0 ? void 0 : (_properties$source3$p = _properties$source3.parameters) === null || _properties$source3$p === void 0 ? void 0 : _properties$source3$p.url);
  }, [properties.source.type, properties.source.defaultValues, (_properties$source$pa = properties.source.parameters) === null || _properties$source$pa === void 0 ? void 0 : _properties$source$pa.url]); // charge text data

  var handleChangeTypeText = function handleChangeTypeText(e) {
    var val = e.target.value;
    setTypeText(val);
    var spl = val.split(",");
    var options = spl.map(function (value) {
      return {
        value: value,
        label: value
      };
    }); // charge data in select

    handleItemSource(properties, "defaultValues", options, false, false);
  };

  var handleChangeTypeServer = function handleChangeTypeServer(e) {
    return setTypeServer(e.target.value);
  };

  var handleCloseAlert = function handleCloseAlert(e, reason) {
    if (reason === "clickaway") {
      return;
    }

    setOpenAlert(_objectSpread(_objectSpread({}, openAlert), {}, {
      open: false
    }));
  };

  var handleOpenAlert = function handleOpenAlert(props) {
    return setOpenAlert(props);
  };

  if (type === "button") {
    return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(BtnForm, {
      properties: properties,
      handleItemSource: handleItemSource
    }));
  }

  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(_core.Tooltip, {
    title: /*#__PURE__*/React.createElement("span", {
      style: {
        whiteSpace: "pre-line"
      }
    }, "- Tipo 1: llenar el select con informaci\xF3n (texto separado por comas) \n\n          - Tipo 2: llenar el select con informaci\xF3n desde un endpoint (formato array objetos: [{label, value}])"),
    "aria-label": "type",
    placement: "left-start"
  }, /*#__PURE__*/React.createElement(_core.FormControl, null, /*#__PURE__*/React.createElement(_core.InputLabel, null, "Tipo"), /*#__PURE__*/React.createElement(_core.Select, {
    name: "type",
    value: typeSelect,
    onChange: function onChange(e) {
      handleItemSource(properties, "type", Number(e.target.value), false, false);
    }
  }, /*#__PURE__*/React.createElement(_core.MenuItem, {
    value: "1"
  }, "1"), /*#__PURE__*/React.createElement(_core.MenuItem, {
    value: "2"
  }, "2"))))), typeSelect === 1 ? /*#__PURE__*/React.createElement(TypeText, {
    typeText: typeText,
    handleChangeTypeText: handleChangeTypeText
  }) : /*#__PURE__*/React.createElement(TypeServer, {
    typeServer: typeServer,
    handleChangeTypeServer: handleChangeTypeServer,
    onOpenAlert: handleOpenAlert,
    properties: properties,
    objectsForm: objectsForm,
    handleItemSource: handleItemSource,
    handleItemDependencies: handleItemDependencies,
    handleAddItemForm: handleAddItemForm,
    gridSize: gridSize
  }), /*#__PURE__*/React.createElement(_Notification.default, {
    openAlert: openAlert.open,
    onCloseAlert: handleCloseAlert,
    message: openAlert.msg,
    type: openAlert.type
  }));
};

var TypeServer = function TypeServer(_ref3) {
  var _properties$source4, _properties$source4$p;

  var typeServer = _ref3.typeServer,
      handleChangeTypeServer = _ref3.handleChangeTypeServer,
      onOpenAlert = _ref3.onOpenAlert,
      properties = _ref3.properties,
      objectsForm = _ref3.objectsForm,
      handleItemSource = _ref3.handleItemSource,
      handleItemDependencies = _ref3.handleItemDependencies,
      handleAddItemForm = _ref3.handleAddItemForm,
      gridSize = _ref3.gridSize;
  var classes = useStyles();

  var _useState9 = (0, _react.useState)(defaultFormData()),
      _useState10 = _slicedToArray(_useState9, 2),
      formData = _useState10[0],
      setFormData = _useState10[1];

  var _useState11 = (0, _react.useState)({
    label: false,
    url: false
  }),
      _useState12 = _slicedToArray(_useState11, 2),
      errors = _useState12[0],
      setErrors = _useState12[1];

  var _useState13 = (0, _react.useState)(false),
      _useState14 = _slicedToArray(_useState13, 2),
      loading = _useState14[0],
      setLoading = _useState14[1];

  var _useState15 = (0, _react.useState)(false),
      _useState16 = _slicedToArray(_useState15, 2),
      openFullModal = _useState16[0],
      setOpenFullModal = _useState16[1];

  var _useState17 = (0, _react.useState)(false),
      _useState18 = _slicedToArray(_useState17, 2),
      openModal = _useState18[0],
      setOpenModal = _useState18[1];

  var DEPENDENCIES = function DEPENDENCIES() {
    var parentSelect = {
      label: properties.attributes.label,
      value: properties.name
    };
    var deps = properties.dependencies.map(function (dp) {
      return {
        label: dp.attributes.label,
        value: dp.name
      };
    });
    return [parentSelect].concat(deps);
  };

  var handleDataRequest = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var open,
          isNotUrl,
          result,
          options,
          _args = arguments;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              open = _args.length > 0 && _args[0] !== undefined ? _args[0] : false;
              setLoading(true);
              isNotUrl = _utils.default.validURL(typeServer);

              if (!(!typeServer || typeServer === "")) {
                _context.next = 7;
                break;
              }

              onOpenAlert({
                open: true,
                type: "warning",
                msg: "El campo no puede estar vacio"
              });
              setLoading(false);
              return _context.abrupt("return");

            case 7:
              if (isNotUrl) {
                _context.next = 11;
                break;
              }

              onOpenAlert({
                open: true,
                type: "error",
                msg: "Url inválida"
              });
              setLoading(false);
              return _context.abrupt("return");

            case 11:
              // open full modal
              if (open) {
                handleClickOpen();
              }

              _context.prev = 12;
              _context.next = 15;
              return (0, _services.default)(typeServer);

            case 15:
              result = _context.sent;
              options = result.map(function (value) {
                return {
                  value: value,
                  label: value
                };
              }); // charge data in select

              handleItemSource(properties, "url", typeServer, false, true);
              handleItemSource(properties, "defaultValues", options, false, false);
              onOpenAlert({
                open: true,
                type: "success",
                msg: "Información cargada con exito en el select"
              });
              _context.next = 25;
              break;

            case 22:
              _context.prev = 22;
              _context.t0 = _context["catch"](12);
              onOpenAlert({
                open: true,
                type: "error",
                msg: "Ocurrió un error, por favor intente mas tarde"
              });

            case 25:
              setLoading(false);

            case 26:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[12, 22]]);
    }));

    return function handleDataRequest() {
      return _ref4.apply(this, arguments);
    };
  }();

  var handleClickOpen = function handleClickOpen() {
    return setOpenFullModal(true);
  };

  var handleClose = function handleClose() {
    return setOpenFullModal(false);
  };

  var handleClickOpenModal = function handleClickOpenModal() {
    setFormData(defaultFormData());
    setOpenModal(true);
  };

  var handleChangeFormData = function handleChangeFormData(e) {
    var check = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var target = e.target; // delete condition dependencies

    setFormData(function (prevData) {
      return _objectSpread(_objectSpread({}, prevData), {}, _defineProperty({}, target.name, target.name === "allowNull" ? check : target.value));
    });

    if (target.name === "label" || target.name === "url") {
      setErrors(function (prevErr) {
        return _objectSpread(_objectSpread({}, prevErr), {}, _defineProperty({}, target.name, target.value === ""));
      });
    }
  };

  var isNotUrlForm = (0, _react.useMemo)(function () {
    return _utils.default.validURL(formData.url);
  }, [formData.url]);
  var checkErrors = (0, _react.useCallback)(function () {
    if (Object.keys(errors).some(function (key) {
      return errors[key] === true;
    }) || formData.label === "" || formData.url === "" || !isNotUrlForm) {
      setErrors({
        label: formData.label === "",
        url: formData.url === "" || !isNotUrlForm
      });
      return true;
    }

    return false;
  }, [errors, formData.label, formData.url, isNotUrlForm]);

  var handleDeleteItem = function handleDeleteItem(item) {
    MySwal.fire({
      title: "Estas seguro que desea eliminar ".concat(item.attributes.label, "?"),
      text: "Esta acción es permanente!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "OK",
      cancelButtonText: "Cancelar"
    }).then( /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(result) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (result.isConfirmed) {
                  handleItemDependencies(properties, item.i, "delete");
                }

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x) {
        return _ref5.apply(this, arguments);
      };
    }());
  };

  var handleEditItem = function handleEditItem(item) {
    setFormData({
      label: item.attributes.label,
      placeholder: item.attributes.placeholder,
      allowNull: item.validations.allowNull,
      url: item.source.parameters.url,
      dependencies: item.dependencies,
      i: item.i,
      name: item.name,
      isEdit: true
    });
    setOpenModal(true);
  };

  var handleSubmitModal = (0, _react.useCallback)( /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(e) {
      var isExistSelect, item, action;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              e.preventDefault(); // check form errors

              if (!checkErrors()) {
                _context3.next = 3;
                break;
              }

              return _context3.abrupt("return");

            case 3:
              // check that the name is not repeated
              isExistSelect = properties.dependencies.some(function (pr) {
                return pr.attributes.label === formData.label;
              });

              if (!(isExistSelect && !formData.isEdit)) {
                _context3.next = 7;
                break;
              }

              onOpenAlert({
                open: true,
                type: "warning",
                msg: "Ya existe un select con el mismo nombre"
              });
              return _context3.abrupt("return");

            case 7:
              item = _objectSpread({}, defaultValues(objectsForm, formData));
              action = formData.isEdit ? "update" : "create";
              handleItemDependencies(properties, item, action); // new item to form builder

              item.isChild = {
                parentId: properties.i
              };
              item.x = gridSize - item.x - 1;
              handleAddItemForm(item);
              setOpenModal(false);

            case 14:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x2) {
      return _ref6.apply(this, arguments);
    };
  }(), // eslint-disable-next-line react-hooks/exhaustive-deps
  [formData, properties, objectsForm]);
  return /*#__PURE__*/React.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(_core.TextField, {
    name: "typeText",
    label: "URL Principal Remota",
    placeholder: "Ej: ".concat(_urls.API_FULL, "/catalog/years"),
    value: ((_properties$source4 = properties.source) === null || _properties$source4 === void 0 ? void 0 : (_properties$source4$p = _properties$source4.parameters) === null || _properties$source4$p === void 0 ? void 0 : _properties$source4$p.url) || typeServer,
    onChange: handleChangeTypeServer,
    InputProps: {
      startAdornment: /*#__PURE__*/React.createElement(_core.Tooltip, {
        title: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
          style: {
            whiteSpace: "pre-line"
          }
        }, "Ingrese el endpoint para llenar el select \n\n                  Debe retornar una estructura como esta:"), /*#__PURE__*/React.createElement("pre", null, /*#__PURE__*/React.createElement("code", null, "[\n  {\n    value: ...,\n    label: ...\n  },\n  {...}\n]"))),
        "aria-label": "typeSelect",
        placement: "left-start"
      }, /*#__PURE__*/React.createElement(_core.InputAdornment, {
        position: "start"
      }, /*#__PURE__*/React.createElement(_HelpOutlineOutlined.default, {
        className: classes.colorHelp
      }))),
      endAdornment: /*#__PURE__*/React.createElement(_core.InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React.createElement(_core.IconButton, {
        "aria-label": "delete",
        className: classes.margin,
        size: "small",
        onClick: function onClick() {
          return handleDataRequest(false);
        }
      }, !loading ? /*#__PURE__*/React.createElement(_core.Tooltip, {
        title: "Click para ejecutar el endpoint",
        "aria-label": "type",
        placement: "bottom"
      }, /*#__PURE__*/React.createElement(_PlayArrowRounded.default, {
        className: classes.playBtn,
        fontSize: "inherit"
      })) : /*#__PURE__*/React.createElement(_core.CircularProgress, {
        size: 20
      })))
    }
  }), /*#__PURE__*/React.createElement(_core.Tooltip, {
    title: "Configure selects dependientes",
    "aria-label": "type",
    placement: "bottom"
  }, /*#__PURE__*/React.createElement(_core.Button, {
    variant: "contained",
    color: "primary",
    onClick: handleDataRequest,
    style: {
      width: "100%",
      marginTop: 100
    }
  }, "Agregar dependencias")), /*#__PURE__*/React.createElement(_FullModal.default, {
    open: openFullModal,
    handleClose: handleClose
  }, /*#__PURE__*/React.createElement(React.Fragment, null, properties.dependencies.length > 0 ? /*#__PURE__*/React.createElement(_core.TableContainer, {
    component: _core.Paper
  }, /*#__PURE__*/React.createElement(_core.Table, {
    className: classes.table,
    "aria-label": "customized table"
  }, /*#__PURE__*/React.createElement(_core.TableHead, null, /*#__PURE__*/React.createElement(_core.TableRow, null, /*#__PURE__*/React.createElement(StyledTableCell, null, "Etiqueta"), /*#__PURE__*/React.createElement(StyledTableCell, {
    align: "center"
  }, "Placeholder"), /*#__PURE__*/React.createElement(StyledTableCell, {
    align: "center"
  }, "Permite nulo?"), /*#__PURE__*/React.createElement(StyledTableCell, {
    align: "center"
  }, "URL Remota"), /*#__PURE__*/React.createElement(StyledTableCell, {
    align: "center"
  }, "Dependencias"), /*#__PURE__*/React.createElement(StyledTableCell, {
    align: "right"
  }, "Acci\xF3n"))), /*#__PURE__*/React.createElement(_core.TableBody, null, properties.dependencies.map(function (item, i) {
    return /*#__PURE__*/React.createElement(StyledTableRow, {
      key: i
    }, /*#__PURE__*/React.createElement(StyledTableCell, {
      component: "th",
      scope: "row"
    }, item.attributes.label), /*#__PURE__*/React.createElement(StyledTableCell, {
      align: "center"
    }, item.attributes.placeholder), /*#__PURE__*/React.createElement(StyledTableCell, {
      align: "center"
    }, item.validations.allowNull ? /*#__PURE__*/React.createElement("b", null, "Si") : /*#__PURE__*/React.createElement("b", null, "No")), /*#__PURE__*/React.createElement(StyledTableCell, {
      align: "center"
    }, item.source.parameters.url), /*#__PURE__*/React.createElement(StyledTableCell, {
      align: "center"
    }, item.dependencies.length > 0 ? item.dependencies.join(" | ") : "-"), /*#__PURE__*/React.createElement(StyledTableCell, {
      align: "right"
    }, /*#__PURE__*/React.createElement(_core.IconButton, {
      color: "primary",
      "aria-label": "edit",
      onClick: function onClick() {
        return handleEditItem(item);
      }
    }, /*#__PURE__*/React.createElement(_Edit.default, null)), /*#__PURE__*/React.createElement(_core.IconButton, {
      "aria-label": "delete",
      onClick: function onClick() {
        return handleDeleteItem(item);
      }
    }, /*#__PURE__*/React.createElement(_Delete.default, null))));
  })))) : /*#__PURE__*/React.createElement("div", {
    className: classes.notFound
  }, /*#__PURE__*/React.createElement(Header, {
    title: "No hay datos"
  })), /*#__PURE__*/React.createElement(_Modal.default, {
    open: openModal,
    onOpen: setOpenModal,
    title: "Crear select dependiente",
    fullWidth: true,
    maxWidth: "md"
  }, /*#__PURE__*/React.createElement(_core.Grid, {
    container: true,
    direction: "column"
  }, /*#__PURE__*/React.createElement("form", {
    onSubmit: handleSubmitModal
  }, /*#__PURE__*/React.createElement(Header, {
    title: "General"
  }), /*#__PURE__*/React.createElement(FieldsGrid, {
    container: true,
    item: true,
    justify: "space-between"
  }, /*#__PURE__*/React.createElement(_core.Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React.createElement(_core.TextField, {
    name: "label",
    id: "label",
    label: "Etiqueta *",
    placeholder: "Ingrese nombre del label",
    value: formData.label,
    onChange: handleChangeFormData,
    error: errors.label,
    helperText: errors.label && "Campo requerido"
  })), /*#__PURE__*/React.createElement(_core.Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React.createElement(_core.TextField, {
    name: "placeholder",
    id: "placeholder",
    label: "Placeholder",
    placeholder: "Ingrese placeholder",
    value: formData.placeholder,
    onChange: handleChangeFormData
  }))), /*#__PURE__*/React.createElement(Header, {
    title: "Validaciones"
  }), /*#__PURE__*/React.createElement(FieldsGrid, {
    container: true,
    item: true,
    justify: "space-between"
  }, /*#__PURE__*/React.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(_core.Tooltip, {
    title: "Determina si el campo es no requerido",
    "aria-label": "allowNull",
    placement: "left-start"
  }, /*#__PURE__*/React.createElement(_core.FormControlLabel, {
    control: /*#__PURE__*/React.createElement(_core.Switch, {
      name: "allowNull",
      color: "primary",
      checked: Boolean(formData.allowNull),
      onChange: function onChange(e, check) {
        return handleChangeFormData(e, check);
      }
    }),
    label: "Permite Nulo"
  })))), /*#__PURE__*/React.createElement(Header, {
    title: "Origen de datos"
  }), /*#__PURE__*/React.createElement(FieldsGrid, {
    container: true,
    item: true,
    justify: "space-between"
  }, /*#__PURE__*/React.createElement(_core.Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React.createElement(_core.TextField, {
    name: "url",
    id: "url",
    label: "URL Remota *",
    placeholder: "Ej: ".concat(_urls.API_FULL, "/catalog/brand"),
    value: formData.url,
    onChange: handleChangeFormData,
    error: errors.url,
    helperText: errors.url && !isNotUrlForm && "No es una Url válida"
  })), /*#__PURE__*/React.createElement(_core.Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React.createElement(_core.FormControl, {
    className: classes.formControl
  }, /*#__PURE__*/React.createElement(_core.InputLabel, {
    id: "dependencies"
  }, "Dependencias"), /*#__PURE__*/React.createElement(_core.Select, {
    name: "dependencies",
    labelId: "dependencies",
    id: "dependencies-select",
    multiple: true,
    value: formData.dependencies,
    onChange: handleChangeFormData,
    input: /*#__PURE__*/React.createElement(_core.Input, null),
    MenuProps: MenuProps
  }, DEPENDENCIES().map(function (el, i) {
    return /*#__PURE__*/React.createElement(_core.MenuItem, {
      key: i,
      value: el.value
    }, el.label);
  }))))), /*#__PURE__*/React.createElement(_core.Grid, {
    container: true,
    justify: "flex-end",
    style: {
      marginTop: 32,
      padding: 8
    }
  }, /*#__PURE__*/React.createElement(_core.Button, {
    variant: "outlined",
    onClick: function onClick() {
      return setOpenModal(false);
    },
    style: {
      marginRight: 16
    }
  }, "Cancelar"), /*#__PURE__*/React.createElement(_core.Button, {
    type: "submit",
    variant: "contained",
    color: "primary"
  }, formData.isEdit ? "Editar" : "Agregar"))))), /*#__PURE__*/React.createElement("div", {
    className: classes.fabFloatingButton
  }, /*#__PURE__*/React.createElement(_core.Fab, {
    color: "primary",
    "aria-label": "add",
    onClick: handleClickOpenModal
  }, /*#__PURE__*/React.createElement(_Add.default, null))))));
};

var TypeText = function TypeText(_ref7) {
  var typeText = _ref7.typeText,
      handleChangeTypeText = _ref7.handleChangeTypeText;
  return /*#__PURE__*/React.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(_core.Tooltip, {
    title: /*#__PURE__*/React.createElement("span", {
      style: {
        whiteSpace: "pre-line"
      }
    }, "Ingrese los valores separados por comas, Ej: \n\n            Valor1,Valor2,Valor3..."),
    "aria-label": "typeSelect",
    placement: "left-start"
  }, /*#__PURE__*/React.createElement(_core.TextField, {
    name: "typeText",
    label: "Valores",
    placeholder: "Ej: Valor1,Valor2,Valor3...",
    value: typeText,
    onChange: handleChangeTypeText
  })));
};

var BtnForm = function BtnForm(_ref8) {
  var _properties$source$pa2, _properties$source$pa3, _properties$source$pa4, _properties$source$pa5;

  var properties = _ref8.properties,
      handleItemSource = _ref8.handleItemSource;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(_core.TextField, {
    name: "server",
    label: "Servidor",
    placeholder: _urls.API_FULL,
    value: (_properties$source$pa2 = properties.source.parameters) === null || _properties$source$pa2 === void 0 ? void 0 : _properties$source$pa2.server,
    onChange: function onChange(e) {
      return handleItemSource(properties, "server", e.target.value);
    }
  })), /*#__PURE__*/React.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(_core.TextField, {
    name: "url",
    label: "Url servicio",
    placeholder: "Ej: form-build",
    value: (_properties$source$pa3 = properties.source.parameters) === null || _properties$source$pa3 === void 0 ? void 0 : _properties$source$pa3.service.url,
    onChange: function onChange(e) {
      return handleItemSource(properties, "service.url", e.target.value, true);
    }
  })), /*#__PURE__*/React.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(_core.TextField, {
    name: "name",
    label: "Nombre servicio",
    placeholder: "Ej: create",
    value: (_properties$source$pa4 = properties.source.parameters) === null || _properties$source$pa4 === void 0 ? void 0 : _properties$source$pa4.service.name,
    onChange: function onChange(e) {
      return handleItemSource(properties, "service.name", e.target.value, true);
    }
  })), /*#__PURE__*/React.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(_core.FormControl, null, /*#__PURE__*/React.createElement(_core.InputLabel, null, "Tipo de operaci\xF3n"), /*#__PURE__*/React.createElement(_core.Select, {
    name: "operation",
    disabled: true,
    value: (_properties$source$pa5 = properties.source.parameters) === null || _properties$source$pa5 === void 0 ? void 0 : _properties$source$pa5.operation,
    onChange: function onChange(e) {
      handleItemSource(properties, "operation", e.target.value);
    }
  }, /*#__PURE__*/React.createElement(_core.MenuItem, {
    value: "POST"
  }, "POST"), /*#__PURE__*/React.createElement(_core.MenuItem, {
    value: "PUT"
  }, "PUT")))));
};

var Header = function Header(_ref9) {
  var title = _ref9.title;
  var classes = useStyles();
  return /*#__PURE__*/React.createElement(_core.Typography, {
    component: "div",
    variant: "h6",
    gutterBottom: true,
    className: classes.titleHeader
  }, title);
};

var defaultValues = function defaultValues(objectsForm, formData) {
  return {
    x: 0,
    y: 0,
    w: 1,
    h: 1,
    classes: "dnd-highlight",
    type: "select",
    attributes: {
      label: formData.label,
      placeholder: formData.placeholder,
      value: "",
      type: "select"
    },
    dependencies: formData.dependencies,
    minH: 1,
    maxH: 1,
    source: {
      type: 2,
      parameters: {
        url: formData.url
      },
      defaultValues: []
    },
    validations: {
      allowNull: formData.allowNull
    },
    i: formData.isEdit ? formData.i : _utils.default.getNewId(),
    name: formData.isEdit ? formData.name : "select".concat(objectsForm.filter(function (oForm) {
      return oForm.type === "select";
    }).length)
  };
};

var defaultFormData = function defaultFormData() {
  return {
    label: "",
    placeholder: "",
    allowNull: false,
    url: "",
    dependencies: [],
    isEdit: false
  };
};

var _default = FormItemSources;
exports.default = _default;